import Api from "@/services/Api";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import KanjiSheet from "@/components/KanjiSheet.vue";
import TermExamples from "@/components/KanjiTermsExamples.vue";

export const EkDetailsMixin = {
  data() {
    return {
      kanjiData: null,
      styleData:{width:200,height:200,frameWidth:200,frameHeight:200},
      tempKanji: this.$route.params.kanji,
    };
  },
  computed: {
    ita() {
      let p = "";
      let v= "";
      try {
        v = this.kanjiData.italian.map(element=>{return element.ita})[0]
        console.log(v);
        p = v.map(e=>{return e.trim().charAt(0).toUpperCase()+e.trim().slice(1) }).filter(e=>e).join(", ");
        return p;
      } catch(err) {
        return "";
      }
    },
    eng() {
      try {
        let i;
        const arr = [];
        for (  i in this.kanjiData.reading_meaning.rmgroup.meaning ) {
          let el = this.kanjiData.reading_meaning.rmgroup.meaning[i];
          if (typeof el == "string") {
            arr.push(el);
          }
        }
        return arr.join(", ");
      } catch(err) {
        return "";
      }
    },
    
    onyomi() {
      if (this.kanjiData) {
        return this.kanjiData.reading_meaning.rmgroup.reading.filter(
          (element) => {
            return element.r_type == "ja_on";
          }
        );
      } else {
        return "";
      }
    },
  },
  components: {
    Header,
    KanjiSheet,/*
    Translation: {
      data() {
        return {
        }
      },
      props:["ita"],
      name:"Translation",
      template:"<span id='trans' v-if='ita'><flag iso=it></flag>{{ita}}</span><span v-else>{{eng}}</span>",
      
    }*/
    TermExamples,
    Footer,
  },
  mounted() {
    this.callKanji();
  },
  methods: {
    callKanji() {
      Api()
        .get("/api/edukanji/kanji?k=" + this.tempKanji, {})
        .then((result) => {
          if (result.data.length) {
            this.kanjiData = result.data[0];
          } else {
            this.kanjiData = null;
          }
        });
    },
    reads(type) {
      const ctype = type == "on" ? "ja_on" : "ja_kun";
      if (this.kanjiData) {
        const obj = this.kanjiData.reading_meaning.rmgroup.reading.filter(
          (element) => {
            return element.r_type == ctype;
          }
        );
        const subset = obj
          .map((o) => {
            return o.value;
          })
          .join(", ");
        return subset;
      } else {
        return "";
      }
    },
  },


}